export default {
  common: {
    welcome: 'Bem-vindo',
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    create: 'Criar',
    search: 'Buscar',
    close: 'Fechar',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    actions: 'Ações',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    yes: 'Sim',
    no: 'Não',
    id: 'ID',
    created_at: 'Criado em',
    noDescription: 'Sem descrição',
    rowsPerPage: 'Linhas por página:',
    noResults: 'Nenhum resultado encontrado',
    noData: 'Nenhum dado cadastrado',
    unknown: 'Desconhecido',
    user: 'Usuário',
    notifications: 'Notificações',
  },
  theme: {
    light: 'Modo claro',
    dark: 'Modo escuro',
  },
  auth: {
    login: 'Login',
    logout: 'Sair',
    email: 'Email',
    password: 'Senha',
    loginButton: 'Entrar',
    invalidCredentials: 'Credenciais inválidas',
    loginSuccess: 'Login realizado com sucesso',
    logoutSuccess: 'Logout realizado com sucesso',
  },
  menu: {
    dashboard: 'Dashboard',
    groups: 'Grupos',
    companies: 'Empresas',
    users: 'Usuários',
    sessions: 'Sessões',
    logs: 'Logs',
    config: 'Configurações',
    systemGalatea: 'Sistema Galatea',
    dicionarioDados: 'Dicionário de Dados',
    dicionarioThor: 'Dicionário Thor',
  },
  groups: {
    title: 'Grupos de Empresas',
    new: 'Novo Grupo',
    edit: 'Editar Grupo',
    name: 'Nome',
    description: 'Descrição',
    uuid: 'UUID',
    generateUuid: 'Gerar novo UUID',
    enforceLimit: 'Aplicar limite de acessos simultâneos',
    enforceLimitShort: 'Aplica limite?',
    enforceLimitHint: 'Ative para limitar o número de sessões simultâneas por usuário em todas as empresas do grupo.',
    limitPerUser: 'Limite de sessões por usuário',
    limitPerUserHint: 'Deixe em branco para ilimitado. Informe um número inteiro maior ou igual a zero.',
    limitPerUserPositive: 'O limite deve ser um número inteiro maior ou igual a zero.',
    limitUnlimited: 'Sem limite',
    permissiveLimit: 'Permitir exceder limite em casos especiais',
    permissiveLimitShort: 'Permissivo?',
    permissiveLimitHint: 'Quando ativado, o sistema permite ultrapassar o limite definido em situações controladas.',
    createSuccess: 'Grupo criado com sucesso!',
    updateSuccess: 'Grupo atualizado com sucesso!',
    deleteSuccess: 'Grupo excluído com sucesso!',
    deleteConfirm: 'Tem certeza que deseja excluir este grupo?',
    deleteWarning: 'Esta ação não pode ser desfeita.',
    searchPlaceholder: 'Buscar por nome ou descrição...',
    noResults: 'Nenhum grupo encontrado',
    noData: 'Nenhum grupo cadastrado',
  },
  companies: {
    title: 'Empresas',
    new: 'Nova Empresa',
    edit: 'Editar Empresa',
    name: 'Nome',
    cnpj: 'CNPJ',
    database: 'Banco de Dados',
    ip: 'IP/Host',
    group: 'Grupo',
    status: 'Status',
    createSuccess: 'Empresa criada com sucesso!',
    updateSuccess: 'Empresa atualizada com sucesso!',
    deleteSuccess: 'Empresa excluída com sucesso!',
    deleteConfirm: 'Tem certeza que deseja excluir esta empresa?',
    deleteWarning: 'Esta ação não pode ser desfeita.',
    searchPlaceholder: 'Buscar por nome, CNPJ ou banco de dados...',
    noResults: 'Nenhuma empresa encontrada',
    noData: 'Nenhuma empresa cadastrada',
  },
  users: {
    title: 'Usuários',
    edit: 'Editar Usuário',
    name: 'Nome',
    email: 'Email',
    accessLevel: 'Nível de Acesso',
    updateSuccess: 'Usuário atualizado com sucesso!',
    linkCompanies: 'Gerenciar Empresas',
    linkCompaniesTitle: 'Gerenciar Empresas - {{name}}',
    linkedCompanies: 'Empresas Vinculadas',
    availableCompanies: 'Empresas Disponíveis',
    link: 'Vincular',
    unlink: 'Desvincular',
    noLinkedCompanies: 'Nenhuma empresa vinculada',
    allLinked: 'Todas as empresas já estão vinculadas',
    searchPlaceholder: 'Buscar por nome ou email...',
    noResults: 'Nenhum usuário encontrado',
    noData: 'Nenhum usuário cadastrado',
    emailCannotBeChanged: 'Email não pode ser alterado',
    userActive: 'Usuário Ativo',
  },
  sessions: {
    title: 'Sessões de Usuários',
    selectUser: 'Selecione um usuário',
    activeSessions: 'Sessões Ativas',
    activeSessionsCount: 'Sessões Ativas: {{valid}} de {{total}}',
    deviceId: 'Device ID',
    deviceName: 'Device Name',
    expiresAt: 'Expira em',
    createdAt: 'Criado em',
    revoke: 'Revogar',
    revokeAll: 'Revogar Todas',
    revokeSuccess: 'Sessão revogada com sucesso!',
    revokeAllSuccess: 'Todas as sessões foram revogadas!',
    valid: 'Válida',
    revoked: 'Revogada',
    noSessions: 'Nenhuma sessão encontrada',
  },
  accessLevels: {
    superAdmin: 'Super Administrador',
    administrator: 'Administrador',
    manager: 'Gerente',
    supervisor: 'Supervisor',
    operator: 'Operador',
    defaultUser: 'Usuário Padrão',
  },
  context: {
    selectTitle: 'Selecione o Modo de Atuação',
    selectSubtitle: 'Escolha como deseja atuar no sistema',
    changeTitle: 'Trocar Contexto de Atuação',
    modeOfAction: 'Modo de Atuação',
    superAdmin: 'Super Administrador',
    superAdminDescription: 'Acesso total ao sistema (gerenciamento de grupos, empresas, backups, configurações globais)',
    administrator: 'Administrador',
    administratorDescription: 'Acesso administrativo em uma empresa específica (selecione a empresa)',
    user: 'Usuário da Empresa',
    userDescription: 'Acesso como usuário comum de uma empresa específica',
    company: 'Empresa',
    companyRequired: 'Empresa *',
    selectCompany: 'Selecione uma empresa',
    noCompanyAvailable: 'Nenhuma empresa disponível para seleção.',
    continue: 'Continuar',
    changeContext: 'Trocar Contexto',
    selectMode: 'Selecione um modo de atuação',
    selectCompanyError: 'Selecione uma empresa',
    saveError: 'Erro ao salvar contexto',
    loadError: 'Erro ao carregar contexto do usuário',
    changeLanguage: 'Alterar idioma',
    switchContextTooltip: 'Trocar contexto de atuação',
  },
  config: {
    title: 'Configurações',
    subtitle: 'Selecione um módulo de configuração para continuar.',
    appearanceTitle: 'Aparência',
    appearanceSubtitle: 'Escolha o tema visual e o modo claro/escuro.',
    options: {
      appearance: {
        title: 'Aparência',
        description: 'Escolha o tema visual e o modo claro/escuro.',
      },
      branding: {
        title: 'Branding',
        description: 'Logo do header e watermark de fundo.',
      },
      system: {
        title: 'Parâmetros do Sistema',
        description: 'Gerencie parâmetros gerais da plataforma Galatea (em breve).',
        comingSoon: 'Em breve',
      },
      dicionario: {
        title: 'Documentação Thor',
        description: 'Visualize e atualize a documentação das tabelas e colunas dos bancos Thor.',
      },
      open: 'Abrir',
    },
    sistemaGalatea: {
      title: 'Sistema Galatea',
      subtitle:
        'Esta área está em desenvolvimento. Em breve você poderá gerenciar recursos centrais da plataforma Galatea por aqui.',
    },
    dicionarioThor: {
      title: 'Documentação Thor',
      subtitle: 'Visualize as colunas documentadas dos bancos Thor.',
      searchPlaceholder: 'Buscar por tabela, coluna ou descrição...',
      error: 'Erro ao carregar dados do dicionário.',
      empty: 'Nenhum registro encontrado.',
      table: 'Tabela',
      column: 'Coluna',
      type: 'Tipo',
      length: 'Tamanho',
      decimals: 'Decimais',
      statusColumn: 'Status',
      description: 'Descrição',
      tableFilter: 'Filtro por tabela',
      tablePlaceholder: 'Ex.: clis, alternativas',
      columnFilter: 'Filtro por coluna',
      columnPlaceholder: 'Ex.: cdcliente, dscoluna',
    },
  },
  themePresets: {
    'galatea-navy': { name: 'Galatea Ultramar', recommendation: 'Administrativo Geral' },
    'emerald-warehouse': { name: 'Esmeralda do Estoque', recommendation: 'WMS / Estoque' },
    'taxation-gold': { name: 'Ouro dos Tributos', recommendation: 'Fiscal / ICMS / IPI' },
    'bpa-cyber': { name: 'BPA Neon', recommendation: 'Automação e IA' },
    'slate-industrial': { name: 'Fábrica Ardósia', recommendation: 'Operação de Longa Duração' },
    'deep-oceanic': { name: 'Azul Abissal', recommendation: 'Logística e Fretes' },
    'ruby-accounting': { name: 'Rubi das Contas', recommendation: 'Financeiro / Auditoria' },
    'amber-logistics': { name: 'Rota Âmbar', recommendation: 'Expedição / Rastreio' },
    'nordic-frost': { name: 'Geada Nórdica', recommendation: 'Relatórios de Gestão' },
    'midnight-tech': { name: 'Circuito Meia‑Noite', recommendation: 'Modo Dev / Usuários Avançados' },
    'coffee-bean': { name: 'Grão Espresso', recommendation: 'Compras e Insumos' },
    'vibrant-violet': { name: 'Violeta Pulsante', recommendation: 'CRM e Vendas' },
    'forest-edge': { name: 'Orla da Floresta', recommendation: 'Sustentabilidade' },
    'electric-blue': { name: 'Azul Relâmpago', recommendation: 'Monitoramento em Tempo Real' },
    'sunset-orange': { name: 'Laranja Crepúsculo', recommendation: 'Gestão de Risco' },
    'steel-grey': { name: 'Aço Fosco', recommendation: 'Cadastros Gerais' },
    'teal-serenity': { name: 'Calmaria Teal', recommendation: 'RH e Colaboradores' },
    'royal-purple': { name: 'Roxo Majestade', recommendation: 'Dashboards de Diretoria' },
    'clay-terracotta': { name: 'Terracota Viva', recommendation: 'Chão de Fábrica' },
    'high-contrast': { name: 'Alto Contraste', recommendation: 'Acessibilidade / Baixa Visão' },
  },
}
